(() => {
  function updateCard(card) {
    const overlay = card.querySelector('.acq-native-card-overlay');
    const link = card.querySelector('[data-product-page-link]');
    if (!overlay || !link) return;
    const badges = overlay.querySelectorAll('[data-acq-badge-variant-id]');
    if (!badges.length) return;
    let variantId = '';
    try {
      variantId = new URL(link.href, location.href).searchParams.get('variant') || '';
    } catch (_) {
      return;
    }
    if (!variantId) variantId = badges[0].dataset.acqBadgeVariantId;
    badges.forEach((badge) => {
      if (badge.dataset.acqBadgeVariantId === variantId) badge.setAttribute('data-acq-badge-active', '');
      else badge.removeAttribute('data-acq-badge-active');
    });
  }

  function scheduleUpdate(event) {
    if (!event.target.closest('.productitem--swatches-input') &&
        !event.target.closest('.productitem--swatches-container label')) return;
    const card = event.target.closest('[data-product-item]');
    if (card) requestAnimationFrame(() => updateCard(card));
  }

  document.addEventListener('change', scheduleUpdate);
  document.addEventListener('click', scheduleUpdate);
})();
